<template>
  <div>
    <div v-if="data.column.name === 'subtype' ">
      <div
        v-for="subtype in subtypes"
        :key="subtype.id"
      >
        <span v-if="data.column.field === subtype.name">
          <b-form-checkbox
            v-model="subtype.checked"
            @change="updateAdFormat(data.row, subtypes)"
          />
        </span>
      </div>
    </div>
    <span>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import DisplayAdsService from '@/api/admin/displayAds.service'
import { ref } from '@vue/composition-api'
import store from '@/store'
import notification from '@/mixins/toastification'
import translate from '@/mixins/translate'

export default {
  mixins: [notification, translate],
  props: {
    data: {
      type: [Array, Object],
    },
  },
  setup(props) {
    const { subtypes } = props.data.row
    const displayAdsModel = ref({})

    const updateAdFormat = async (row, types) => {
      displayAdsModel.value = {
        formatId: row.formatId,
        formatName: row.formatName,
        height: row.height,
        width: row.width,
        subtypes: types,
      }
      const displayAds = Object.keys(displayAdsModel).map(key => displayAdsModel[key])

      try {
        const response = await DisplayAdsService.updateDisplayAds(displayAds)
        if (response) {
          notification.methods.success(translate.methods.$tk('EditCampaign.ChangesHaveBeenSavedSuccesfully'))
        } else {
          notification.methods.error(translate.methods.$tk('EditCampaign.FailedToUpdate'))
        }
      } catch (err) {
        notification.methods.error(err.message)
      } finally {
        await store.dispatch('getDisplayAds')
      }
    }

    return { subtypes, updateAdFormat }
  },
}
</script>

<style>

</style>
